<div class="bundle-container" (mousedown)="onCloseCryptoCard()">
  <div class="info">
    <p class="title">¿Qué son las canastas?</p>
    <p class="description">
      Las canastas son paquetes que están compuestos por diferentes activos y siguen una temática en
      común. Es decir que al comprar una canasta, estás comprando un conjunto de activos diferentes.
      Es importante saber que no podés retirar los activos de la canasta, sólo podés comprarlas y
      venderlas.
    </p>
    <img src="/assets/icons/question-icon.svg" alt="" class="background" />
  </div>

  <div
    class="cards-section"
    *ngIf="!detailCardOpened"
    [ngClass]="detailCardOpened ? 'hide' : 'show scrollable'"
  >
    <app-basic-crypto-card
      *ngFor="let bundle of bundles"
      [bundle]="bundle"
      [bundleVariation]="variations ? variations[bundle?.ticker] : 0"
      (click)="selectBundle(bundle)"
      [isBundle]="true"
    ></app-basic-crypto-card>
  </div>
  <div class="blur-background" [class.hide]="!detailCardOpened"></div>
</div>

<app-crypto-bundle-detail-card
  *ngIf="detailCardOpened"
  [bundle]="selectedBundle"
  [variation]="variations[selectedBundle.ticker]"
  [isArsCurrency]="currency === 'ARS'"
  (closeEvent)="onCloseCryptoCard()"
  (mousedown)="$event.stopPropagation()"
>
</app-crypto-bundle-detail-card>
